import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FiberSmartRecordIcon(props: IconProps) {
    return <Icon {...props} iconKey={"fiber_smart_record"}/>
}
